import {useRef} from "react";

export default function useLiveRef(value: any) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
